/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from 'react'
import { TextEffectTyping } from './TextEffectTyping'
import { TextEffectFade } from './TextEffectFade'
import { TextEffectScramble } from './TextEffectScramble'
import { TextEffectColorCycle } from './TextEffectColorCycle'

const effectMap = {
	typing: TextEffectTyping,
	fade: TextEffectFade,
	scramble: TextEffectScramble,
	colorCycle: TextEffectColorCycle
}

export function withTextEffect(BaseComponent) {
	const Wrapped = React.forwardRef(
		({ textEffect, textEffectProps = {}, children, ...rest }, ref) => {
			const EffectComponent = textEffect && effectMap[textEffect]

			// Always strip textEffect + textEffectProps from what reaches the DOM
			if (!EffectComponent) {
				return (
					<BaseComponent ref={ref} {...rest}>
						{children}
					</BaseComponent>
				)
			}

			return (
				<BaseComponent ref={ref} {...rest}>
					<EffectComponent {...textEffectProps}>
						{children}
					</EffectComponent>
				</BaseComponent>
			)
		}
	)
	Wrapped.displayName = `WithTextEffect(${
		BaseComponent.displayName || BaseComponent.name || 'Component'
	})`
	return Wrapped
}
